import { Tv, Zap, ShieldCheck, Headphones, Crown, Gamepad2 } from "lucide-react";

const items = [
  { icon: Tv, title: "600+ HD Channels", body: "Crystal-clear picture quality with over 600 channels including premium HD content." },
  { icon: Zap, title: "Quick Installation", body: "Professional installation within 24–48 hours of booking with zero hidden charges." },
  { icon: ShieldCheck, title: "1 Year Warranty", body: "Peace of mind with comprehensive warranty on equipment and services." },
  { icon: Headphones, title: "24/7 Support", body: "Round-the-clock customer support for any technical or service query." },
  { icon: Crown, title: "Premium Content", body: "Exclusive movies, web series, and live sports from top broadcasters." },
  { icon: Gamepad2, title: "Interactive Services", body: "Gaming, music, and interactive apps for an enhanced experience." },
];

export function WhyChoose() {
  return (
    <section className="bg-secondary/40 py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-black tracking-tight sm:text-4xl">
            Why Choose <span className="text-accent">New DTH?</span>
          </h2>
          <p className="mt-3 text-muted-foreground">
            Experience the future of television with India's most trusted DTH service provider.
          </p>
        </div>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map(({ icon: Icon, title, body }) => (
            <div key={title} className="group rounded-2xl border border-border bg-card p-6 transition hover:-translate-y-0.5 hover:shadow-[var(--shadow-elevated)]">
              <span className="inline-grid h-12 w-12 place-items-center rounded-xl bg-accent/10 text-accent transition group-hover:bg-accent group-hover:text-accent-foreground">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 text-lg font-bold">{title}</h3>
              <p className="mt-1 text-sm text-muted-foreground">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
